interface PatientTableCardHeaderProps {
    isSyncing: boolean;
    hasActiveFilters: boolean;
    filteredCount: number;
    searchTerm: string;
}

/** Background-refresh + active-filter banners, rendered above the column header via DataTable's `cardHeader` slot. */
export function PatientTableCardHeader({
    isSyncing,
    hasActiveFilters,
    filteredCount,
    searchTerm
}: PatientTableCardHeaderProps) {
    return (
        <>
            {isSyncing && (
                <div className="px-6 py-2.5 border-b border-gray-200 bg-gradient-to-r from-blue-50/50 to-white flex items-center gap-2.5">
                    <div className="animate-spin h-3.5 w-3.5 border-2 border-blue-400 border-t-transparent rounded-full"></div>
                    <p className="text-sm text-gray-600 font-medium">Syncing latest data...</p>
                </div>
            )}
            {hasActiveFilters && (
                <div className="px-6 py-3 border-b border-gray-200 bg-gray-50">
                    <p className="text-sm text-gray-600">
                        {filteredCount === 0
                            ? `No patients found${searchTerm ? ` matching "${searchTerm}"` : ''}`
                            : `Found ${filteredCount} patient${filteredCount === 1 ? '' : 's'}${searchTerm ? ` matching "${searchTerm}"` : ''}`}
                    </p>
                </div>
            )}
        </>
    );
}
